import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import Spinner from '@atlaskit/spinner/spinner';
import { N40 } from '@atlaskit/theme/colors';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SpinnerContainer = styled.div({
	display: 'block',
	height: `${148 + 32}px`,
	width: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SpinnerContent = styled.div({
	position: 'absolute',
	top: 0,
	left: 0,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	height: '148px',
	width: '100%',
	border: `1px solid ${token('color.border', N40)}`,
});

export default class CommentSpinner extends Component {
	componentDidMount() {
		this.props.onDidMount();
	}

	render() {
		return (
			<SpinnerContainer>
				<SpinnerContent>
					<Spinner size="medium" />
				</SpinnerContent>
			</SpinnerContainer>
		);
	}
}

CommentSpinner.displayName = 'CommentSpinner';
CommentSpinner.defaultProps = {
	onDidMount: () => {},
};
CommentSpinner.propTypes = {
	/**
	 * function to call when component is mount
	 */
	onDidMount: PropTypes.func,
};
